import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class PdpFoodCategoryLinkApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.PDPFoodCategoryLink;

  constructor(private label: string, private action: string) {}

  getPayload(): any {
    return {
      label: this.label,
      action: this.action,
    };
  }
}
